import { shouldReloadForFailedChunk } from '~/utils/chunkReload'

export default defineNuxtPlugin(() => {
  window.addEventListener('vite:preloadError', (event) => {
    const preloadError = event as Event & { payload?: unknown }
    if (!shouldReloadForFailedChunk(preloadError.payload, window.sessionStorage)) return
    event.preventDefault()
    window.location.reload()
  })
})
